/**
 * Square-with-pencil edit glyph used on annotation and screenshot cards.
 *
 * @param props.width - SVG width (defaults to `14`)
 * @param props.height - SVG height (defaults to `14`)
 * @param props.stroke - Stroke colour (defaults to `currentColor`)
 * @param props.className - Optional class applied to the SVG
 * @returns The rendered edit-square icon
 */
interface EditSquareIconProps {
  width?: string | number;
  height?: string | number;
  stroke?: string;
  className?: string;
}

export const EditSquareIcon = (props: EditSquareIconProps) => {
  const width = props.width ?? 14;
  const height = props.height ?? 14;
  const stroke = props.stroke ?? "currentColor";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={props.className}
      aria-hidden="true"
    >
      <path
        d="M9 2.5h4.5V7M13.2 2.8 7.5 8.5M7 4H3.5A1.5 1.5 0 0 0 2 5.5v7A1.5 1.5 0 0 0 3.5 14h7a1.5 1.5 0 0 0 1.5-1.5V9"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
